import React from "react";

interface TabProps {
  id: string;
  label: string;
}

interface TabItemProps {
  tabList: Partial<TabProps>[];
  activeTab: string;
  handleClick: (d: any) => void;
}

const SimpleTabItems: React.FC<TabItemProps> = ({
  tabList = [],
  activeTab = "",
  handleClick = () => {},
}) => {
  return (
    <div className="simple-tab-wrapper">
      <div className="simple-tab-scroll">
        <div className="simple-tab-list">
          {tabList?.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => handleClick(tab)}
              className={`simple-tab-btn ${
                activeTab === tab.id ? "active" : ""
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SimpleTabItems; 